import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  status: 'idle',
  error: null,
};

const carsSlice = createSlice({
  name: 'cars',
  initialState,
  reducers: {
    setCars(state, action) {
      state.items = action.payload;
      state.error = null;
    },
  },
});

export const { setCars } = carsSlice.actions;
export default carsSlice.reducer;


